import { savePushSubscription } from "../server/push.functions"
import { urlBase64ToUint8Array } from "./vapid"

export const subscribeToPush = async () => {
  if (typeof Notification === "undefined") throw new Error("notifications are not supported")
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    throw new Error("service worker is not supported")
  }

  const permission = await Notification.requestPermission()
  if (permission !== "granted") throw new Error("permission denied")
  const registration = await navigator.serviceWorker.ready
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY),
  })
  const json = subscription.toJSON()
  await savePushSubscription({
    data: {
      endpoint: subscription.endpoint,
      p256dh: json.keys?.p256dh ?? "",
      auth: json.keys?.auth ?? "",
      userAgent: navigator.userAgent,
    },
  })
  return subscription
}
